// import React, { useEffect, useState } from "react";
// import Upload from "../../common/Upload";
// import {
//   fetchDocumentOption,
//   fetchSampleDocumentDetails,
//   uploadDocuments,
// } from "../../../services/user.services";
// import { useDispatch, useSelector } from "react-redux";
// // import Loader from "../../common/Loader"; // Import the Loader component
// import Loader from "../../admin/leads/Loader";
// import QuestionaireDownload from "../../common/QuestionaireDownload";
// import { getStudentDetails } from "../../../services/admin.services";
// import { setUserDetails } from "../../../state/reducers/userSlice";

// const CVUpload = () => {
//   const dispatch = useDispatch();
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false); // State for loader
//   const user_id = useSelector((state) => state.user.user_id);
//   const [isUploaded, setIsUploaded] = useState(false);
//   const studentDetails = useSelector((state) => state.user.userDetails);
//   const socket = useSelector((state) => state.user.socket);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [studentLevels, setStudentLevels] = useState([]);
//   const handleFileSelection = (file) => {
//     if (!isUploaded) {
//       setUploadedFile(file);
//     }
//   };

//   const getStudentProfile = async (user_id) => {
//     try {
//       const res = await getStudentDetails(user_id);
//       dispatch(setUserDetails(res.data));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const fetchLevels = async () => {
//     try {
//       const data = await fetchDocumentOption();
//       const levels = [...new Set(data.map((item) => item.student_level))];
//       setStudentLevels(levels);
//     } catch (error) {
//       console.error("Error fetching document options:", error);
//     }
//   };
//   useEffect(() => {
//     fetchLevels();
//   }, []);

//   useEffect(() => {
//     const hasUploaded = localStorage.getItem(`cvUploaded_${user_id}`);
//     if (hasUploaded) {
//       setIsUploaded(true);
//     }
//   }, [user_id]);

//   const handleSubmit = async () => {
//     if (!uploadedFile) {
//       alert("Please upload a file before submitting.");
//       return;
//     }

//     setIsSubmitting(true); // Show loader
//     const formData = new FormData();
//     formData.append("files", uploadedFile, uploadedFile.name);
//     formData.append("document_type", "resume_cv");

//     try {
//       const response = await uploadDocuments(formData);

//       alert("CV uploaded successfully!");
//       setIsUploaded(true); // ✅ Lock upload after success
//       localStorage.setItem(`cvUploaded_${user_id}`, "true"); // ✅ Save upload status

//       if (socket) {
//         socket.send(
//           JSON.stringify({
//             file_urls: response.data.uploaded_urls,
//             sender_id: user_id,
//             receiver_id:
//               studentDetails.assigned_admins.assigned_content_writer?.id,
//             room: socket.url.split("/")[5],
//           })
//         );
//       }
//       // "check", response.data.uploaded_urls);
//       await getStudentProfile(user_id);
//     } catch (error) {
//       console.error("Upload Error:", error);
//       alert("Failed to upload CV.");
//     } finally {
//       setIsSubmitting(false); // Hide loader
//     }
//   };

//   useEffect(() => {
//     if (studentDetails.resume_cv_url === null) {
//       setIsUploaded(false);
//     } else {
//       setIsUploaded(true);
//     }
//   }, [studentDetails]);
//   const handleDownload = async () => {
//     if (!selectedCategory) return;

//     try {
//       const data = await fetchSampleDocumentDetails(selectedCategory);

//       // const docEntry = data?.find(
//       //   (entry) => entry.student_level === selectedCategory
//       // );
//       // "docEntry", docEntry);

//       const fileUrl = data?.cv_resume?.[0]; // Use "cv_resume" or "lor_doc" in CV or LOR section

//       if (!fileUrl) {
//         alert("No SOP file available for this category.");
//         return;
//       }

//       const link = document.createElement("a");
//       link.href = `${process.env.REACT_APP_BASE_URL}/media/${fileUrl}`;
//       link.setAttribute("download", fileUrl.split("/").pop());
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error("Failed to download SOP:", error);
//       alert("Error downloading SOP file.");
//     }
//   };
//   return (
//     <>
//       <div className="py-8">
//         <QuestionaireDownload
//           text={"Download CV sample"}
//           selectedCategory={selectedCategory}
//           setSelectedCategory={setSelectedCategory}
//           handleDownload={handleDownload}
//           studentLevels={studentLevels}
//         />
//       </div>
//       <h2 className="text-xl font-semibold mb-2">Upload your CV</h2>
//       <p className="text-gray-600 mb-4">
//         Please upload your Resume in Word Document only
//       </p>

//       {!isUploaded ? (
//         <div className="mt-8">
//           <Upload
//             text={"Click here to upload your CV"}
//             onFileUpload={handleFileSelection}
//           />
//         </div>
//       ) : (
//         <p className="text-green-600 font-semibold mt-4">
//           ✅ CV uploaded successfully! You cannot upload again.
//         </p>
//       )}

//       <div className="mt-16 flex justify-end items-center gap-5">
//         <button className="text-gray-600 hover:text-gray-800">Cancel</button>
//         <button
//           className={`bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded flex items-center ${
//             isSubmitting || isUploaded ? "opacity-70 cursor-not-allowed" : ""
//           }`}
//           onClick={handleSubmit}
//           disabled={isSubmitting || isUploaded} // ✅ Disable after first upload
//         >
//           {isSubmitting ? (
//             <Loader />
//           ) : (
//             <>
//               <svg
//                 className="w-5 h-5 mr-2"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//               {isUploaded ? "Uploaded" : "Submit"}
//             </>
//           )}
//         </button>
//       </div>
//     </>
//   );
// };

// export default CVUpload;
import React, { useEffect, useState } from "react";
import Upload from "../../common/Upload";
import {
  fetchDocumentOption,
  fetchSampleDocumentDetails,
  uploadDocuments,
} from "../../../services/user.services";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../admin/leads/Loader";
import QuestionaireDownload from "../../common/QuestionaireDownload";
import { getStudentDetails } from "../../../services/admin.services";
import { setUserDetails } from "../../../state/reducers/userSlice";

// ✅ Import WebSocket provider (same as Comments.jsx)
import { useWebSocket } from "../../../state/reducers/WebSocketProvider";

const genId = () => `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

const CVUpload = () => {
  const dispatch = useDispatch();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [studentLevels, setStudentLevels] = useState([]);

  const user_id = useSelector((state) => state.user.user_id);
  const studentDetails = useSelector((state) => state.user.userDetails);

  // ✅ Use WebSocket provider (don't create connection, just use existing one)
  const { sendMessage, getConnectionState } = useWebSocket();

  // ✅ Room key matches Comments.jsx routing logic
  const roomKey = "cv_upload";

  const receiverId =
    studentDetails?.assigned_admins?.assigned_content_writer?.id || null;

  // ✅ Get connection state (created by Comments component)
  const connectionState = getConnectionState(roomKey, user_id);

  const handleFileSelection = (file) => {
    if (!isUploaded) {
      setUploadedFile(file);
    }
  };

  const getStudentProfile = async (user_id) => {
    try {
      const res = await getStudentDetails(user_id);
      dispatch(setUserDetails(res.data));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLevels = async () => {
    try {
      const data = await fetchDocumentOption();
      const levels = [...new Set(data.map((item) => item.student_level))];
      setStudentLevels(levels);
    } catch (error) {
      console.error("Error fetching document options:", error);
    }
  };

  useEffect(() => {
    fetchLevels();
  }, []);

  useEffect(() => {
    const hasUploaded = localStorage.getItem(`cvUploaded_${user_id}`);
    if (hasUploaded) {
      setIsUploaded(true);
    }
  }, [user_id]);

  // ✅ Monitor connection state
  useEffect(() => {
    console.log("🔍 CVUpload connection state:", {
      roomKey,
      status: connectionState?.status,
      receiverId,
    });
  }, [connectionState, roomKey, receiverId]);

  // ✅ Upload files to chat backend (same as Comments.jsx)
  const uploadFilesToChat = async (files) => {
    if (!files || files.length === 0) return [];

    try {
      const formData = new FormData();
      const fileArray = Array.isArray(files) ? files : [files];

      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      // Add metadata
      const roomname = `${roomKey}_${user_id}`;
      formData.append("roomname", roomname);
      formData.append("sender_id", user_id);

      console.log("📤 CVUpload: Uploading files to chat backend:", {
        roomname,
        fileCount: fileArray.length,
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/chat_app/api/upload-files/`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Chat file upload failed");
      }

      const data = await response.json();
      console.log("✅ CVUpload: Chat files uploaded:", data);

      return data.file_urls || [];
    } catch (error) {
      console.error("❌ CVUpload: Chat file upload error:", error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    if (!uploadedFile) {
      alert("Please upload a file before submitting.");
      return;
    }

    if (!receiverId) {
      alert("Assigned content writer not found. Please contact support.");
      return;
    }

    // ✅ Check if connection exists (from Comments component)
    if (!connectionState || connectionState.status !== "connected") {
      alert(
        "Chat is not connected. Please open the chat tab first and try again."
      );
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("files", uploadedFile, uploadedFile.name);
    formData.append("document_type", "resume_cv");

    try {
      // ✅ STEP 1: Upload to document system
      console.log("📤 CVUpload Step 1: Uploading to document system...");
      const response = await uploadDocuments(formData);

      // ✅ STEP 2: Upload to chat system
      console.log("📤 CVUpload Step 2: Uploading to chat system...");
      const chatFileUrls = await uploadFilesToChat([uploadedFile]);

      if (!chatFileUrls || chatFileUrls.length === 0) {
        throw new Error("Failed to upload file to chat system");
      }

      // ✅ STEP 3: Send message via existing WebSocket connection
      console.log(
        "📤 CVUpload Step 3: Sending message with file attachment..."
      );
      const cid = genId();

      sendMessage(roomKey, user_id, {
        message: "✅ CV uploaded successfully",
        sender_id: user_id,
        receiver_id: receiverId,
        client_message_id: cid,
        file_urls: chatFileUrls,
      });

      console.log("✅ CV upload and chat notification complete");

      alert("CV uploaded successfully!");
      setIsUploaded(true);
      localStorage.setItem(`cvUploaded_${user_id}`, "true");

      // Refresh student profile
      await getStudentProfile(user_id);
    } catch (error) {
      console.error("❌ Upload Error:", error);
      alert(error.message || "Failed to upload CV. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (studentDetails?.resume_cv_url === null) {
      setIsUploaded(false);
    } else {
      setIsUploaded(true);
    }
  }, [studentDetails]);

  const handleDownload = async () => {
    if (!selectedCategory) return;

    try {
      const data = await fetchSampleDocumentDetails(selectedCategory);
      const fileUrl = data?.cv_resume?.[0];

      if (!fileUrl) {
        alert("No CV sample available for this category.");
        return;
      }

      const link = document.createElement("a");
      link.href = `${process.env.REACT_APP_BASE_URL}/media/${fileUrl}`;
      link.setAttribute("download", fileUrl.split("/").pop());
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download CV sample:", error);
      alert("Error downloading CV sample file.");
    }
  };

  return (
    <>
      <div className="py-8">
        <QuestionaireDownload
          text={"Download CV sample"}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          handleDownload={handleDownload}
          studentLevels={studentLevels}
        />
      </div>

      {/* ✅ CONNECTION STATUS WARNINGS */}
      {!connectionState?.status && (
        <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-yellow-800 text-sm font-medium">
            ⚠️ Chat not connected
          </p>
          <p className="text-yellow-600 text-xs mt-1">
            Please open the "CV Upload" chat tab first to enable notifications.
          </p>
        </div>
      )}

      {connectionState?.status === "connecting" && (
        <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            <span className="text-blue-800 text-sm">Chat is connecting...</span>
          </div>
        </div>
      )}

      {connectionState?.status === "connected" && (
        <div className="mb-4 flex items-center gap-2">
          <span className="flex items-center gap-1 text-xs text-green-600">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            Chat connected - uploads will notify admin
          </span>
        </div>
      )}

      {!receiverId && studentDetails && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-800 text-sm font-medium">
            ⚠️ No content writer assigned
          </p>
          <p className="text-red-600 text-xs mt-1">
            Please contact support to assign a content writer before uploading.
          </p>
        </div>
      )}

      <h2 className="text-xl font-semibold mb-2">Upload your CV</h2>
      <p className="text-gray-600 mb-4">
        Please upload your Resume in Word Document only
      </p>

      {!isUploaded ? (
        <div className="mt-8">
          <Upload
            text={"Click here to upload your CV"}
            onFileUpload={handleFileSelection}
          />
        </div>
      ) : (
        <p className="text-green-600 font-semibold mt-4">
          ✅ CV uploaded successfully! You cannot upload again.
        </p>
      )}

      <div className="mt-16 flex justify-end items-center gap-5">
        <button className="text-gray-600 hover:text-gray-800">Cancel</button>
        <button
          className={`bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded flex items-center ${
            isSubmitting ||
            isUploaded ||
            connectionState?.status !== "connected"
              ? "opacity-70 cursor-not-allowed"
              : ""
          }`}
          onClick={handleSubmit}
          disabled={
            isSubmitting ||
            isUploaded ||
            connectionState?.status !== "connected"
          }
        >
          {isSubmitting ? (
            <Loader />
          ) : (
            <>
              <svg
                className="w-5 h-5 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                  clipRule="evenodd"
                />
              </svg>
              {isUploaded ? "Uploaded" : "Submit"}
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default CVUpload;
